import { useMemo } from 'react'

import { STATE_ABBREVIATIONS } from '../../FiltersSiderbar/Filters'
import { FilterOption } from '../types'

interface UseStatesFilterProps {
  selectedStates: string[]
  onStatesChange: (states: string[]) => void
}

const STATE_OPTIONS: FilterOption[] = STATE_ABBREVIATIONS.map((state) => ({
  label: state,
  value: state,
}))

export const useStatesFilter = ({
  selectedStates,
  onStatesChange,
}: UseStatesFilterProps) => {
  const options = useMemo(() => {
    return STATE_OPTIONS.map((option) => ({
      ...option,
      selected: selectedStates.includes(option.value),
    }))
  }, [selectedStates])

  return {
    options,
    selected: selectedStates,
    onChange: onStatesChange,
    loadData: () => {},
    loading: false,
    isLoaded: true,
  }
}
